import React, { useState, useEffect, useRef } from "react";
import { Col, Image, Button, Modal, OverlayTrigger, Tooltip } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import Axios from "axios";

//STYLES
import * as SlotStyles from "../styles/slot";

//IMAGES
import albumImage from "../Images/photoAlbumIcon.png";

function ImageSlot(props) {
    const navigate = useNavigate();

    const textRef = useRef(null);

    const [text, setText] = useState();
    const [textOverflow, setTextOverflow] = useState(false);

    const [over, setOver] = useState(false);

    const [modalYN, setModalYN] = useState({
        open: false,
        heading: "",
        message: "",
        acceptFunction: "",
        acceptName: "",
        showAccept: false,
        cancelName: "",
        showCancel: false
    });

    function handleModalYNClose() {
        setModalYN((prevState) => {
            return { ...prevState, open: false };
        });
    }

    useEffect(() => {
        setText(props.name.replaceAll("_", " "));
    }, []);

    //Screenshot_2025-05-10_at_10.24.49.png

    useEffect(() => {
        if (textRef != null) {
            if (textRef.current.scrollHeight > textRef.current.offsetHeight + 2) {
                // console.log(textRef.current.scrollHeight);
                // console.log(textRef.current.offsetHeight);
                setText(`${text.substring(0, 30)}...`);
                setTextOverflow(true);
            }
        }
    }, [text]);

    function handleMouseEnter() {
        setOver(true);
    }

    function handleMouseLeave() {
        setOver(false);
    }

    function handleDelete(imageUrl) {
        setModalYN({
            heading: "Delete Image",
            message: "Are you sure you want to delete this image?",
            showAccept: true,
            acceptName: "Yes",
            acceptFunction: acceptDeleteImage.bind(this, imageUrl),
            showCancel: true,
            cancelName: "No",
            open: true
        });
    }

    function acceptDeleteImage(imageUrl) {
        setModalYN((prevState) => {
            return { ...prevState, open: false };
        });

        const data = {
            imageUrl: imageUrl,
            album: props.album
        };
        Axios.post("/pods/CPOD_PHOTOANDVIDEOGALLERY_ADMIN/deleteImage", data)
            .then((res) => {
                const data = res.data;
                console.log(data);
                if (data.error == "null") {
                    props.albumload();
                }
            })
            .catch((err) => {
                console.log(err);
            });
    }

    function handleOpenMoveModal(currentAlbum, imageURL) {
        props.openMoveModal(currentAlbum, imageURL);
    }

    return (
        <div style={SlotStyles.imageBody} onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
            <div style={over ? SlotStyles.imageCardTopShow : SlotStyles.imageCardTopHidden}>
                <Button onClick={handleOpenMoveModal.bind(this, props.album, props.name)}>
                    <i className="fa-solid fa-angle-right"></i>
                </Button>
                <Button onClick={handleDelete.bind(this, props.name)}>
                    <i className="fas fa-trash-alt"></i>
                </Button>
            </div>
            <div style={SlotStyles.cardPicture}>
                <br />
                <Image
                    src={`/content/photoAndVideoGallery/${props.album}/${props.name}`}
                    style={SlotStyles.albumImage}
                    onClick={props.openViewer.bind(this, `/content/photoAndVideoGallery/${props.album}/${props.name}`)}
                />
            </div>
            {textOverflow ? (
                <OverlayTrigger placement="bottom" overlay={<Tooltip>{props.name.replaceAll("_", " ")}</Tooltip>}>
                    <div ref={textRef} style={SlotStyles.cardText}>
                        {text}
                    </div>
                </OverlayTrigger>
            ) : (
                <div style={SlotStyles.cardText} ref={textRef}>
                    {text}
                </div>
            )}
            <Modal show={modalYN.open} onHide={handleModalYNClose}>
                <Modal.Header closeButton>
                    <Modal.Title>{modalYN.heading}</Modal.Title>
                </Modal.Header>
                <Modal.Body>{modalYN.message}</Modal.Body>
                <Modal.Footer>
                    {modalYN.showAccept ? (
                        <div>
                            <Button variant="primary" onClick={modalYN.acceptFunction}>
                                {modalYN.acceptName}
                            </Button>
                        </div>
                    ) : null}
                    {modalYN.showCancel ? (
                        <div>
                            <Button variant="primary" onClick={handleModalYNClose}>
                                {modalYN.cancelName}
                            </Button>
                        </div>
                    ) : null}
                </Modal.Footer>
            </Modal>
        </div>
    );
}

export default ImageSlot;
